
















import {Component, Prop, Vue} from 'vue-property-decorator';
import SlideBarComponents from '@/components/layout/SlideBar.vue';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import PaymentJobRunningComponent from '@/components/payment/payment-job-running.vue';

@Component({
  components: {
    PaymentJobRunningComponent,
    SlideBarComponents
  }
})
export default class BgThemePublic extends Vue {
  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;

  public jobRunning = false;

  async mounted() {
    if (this.loginInfo != null) {
      this.jobRunning = true;
    }

  }

}
